import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFeedback$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFeedback extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '24bc36019bad672c2c14b32beb017157b35aa1c6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a4d156d1a94c2bea9749b6a89a27de71a5268146', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e9e4415f02c05de8c0f73b754ae84cfd69a972bb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m16.188 14.51-.955.675.422 1.091q.162.417.362.822a7.5 7.5 0 0 1-2.303-1.27l-.412-.331H8.945c-1.508 0-2.85-.561-3.856-1.58a5.52 5.52 0 0 1-1.59-3.908c0-3.038 2.435-5.51 5.426-5.51h4.129c1.436 0 2.802.573 3.845 1.611.25.253.467.511.634.757.634.927.968 2.004.968 3.121 0 1.807-.865 3.498-2.313 4.522m.866 1.225A7.03 7.03 0 0 0 20 9.988a7 7 0 0 0-1.227-3.962 7 7 0 0 0-.816-.98C16.688 3.783 14.968 3 13.054 3h-4.13C5.098 3 2 6.135 2 10.009c0 1.938.775 3.701 2.022 4.964a6.75 6.75 0 0 0 4.925 2.024h3.827a9.05 9.05 0 0 0 5.7 2.003c.279 0 .43-.348.236-.566a9.1 9.1 0 0 1-1.656-2.699", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-feedback", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-feedback"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-feedback":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFeedback$1);
            }
            break;
    } });
}

const CosmosIconFeedback = CosmosIconFeedback$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFeedback, defineCustomElement };
